export class OrderItem {
    id: number;
    order_id: number;
    product_id: number;
    quantity: number;
    backorder_quantitiy: number;
    total_incl: number;
    total_excl: number;
    total_base_incl: number;
    total_base_excl: number;
    price_incl: number;
    price_excl: number;
    product_name: string;
    product_ean: string;
    product_sku: string;
    sale_active: boolean;
    sale_type: any;
    sale_amount: number;
    voucher_discount: boolean;
    crm_offer_package_id: number;
    created_at: string;
    updated_at: string;
    is_retour: boolean;
}


// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/order_item.ts